import angular from 'angular';
import ngCookies from 'angular-cookies';
import ngResource from 'angular-resource';
import ngSanitize from 'angular-sanitize';
import uiRouter from 'angular-ui-router';

import appModule from './app';

angular.module('pingsta', [
  ngCookies,
  ngResource,
  ngSanitize,
  uiRouter,
  appModule.name,
])



// WEBPACK FOOTER //
// ./src/index.js